import React from "react";
import {
  Bar,
  YAxis,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  ReferenceLine,
} from "recharts";
import PropTypes from "prop-types";
import { schemeTableau10 } from "d3-scale-chromatic";
import dayjs from "dayjs";
import CustomTooltip from "./Tooltip";
import ChartWrapper from "./ChartWrapper";
import Annotation from "./Annotation";

const Chart = ({
  title,
  data,
  xAxisKey,
  yAxisKey,
  yAxisWidth,
  xAxisHeight,
  includePercent,
  xAxisLabel,
  xAxisTickFormatter,
  yAxisTickFormatter,
  tooltipFormatter,
  tooltipLabelFormatter,
}) => {
  const UNIX_BAN_LIFTED = dayjs("2020-08-31").unix();
  const UNIX_CDC = dayjs("2020-09-04").unix();
  return (
    <ChartWrapper title={title}>
      <ResponsiveContainer>
        <BarChart
          width={500}
          height={800}
          data={data}
          margin={{
            top: 50,
            right: 9,
            left: 0,
            bottom: 0,
          }}
        >
          <XAxis
            tick={{ fontSize: 16 }}
            axisLine={false}
            tickLine={false}
            height={xAxisHeight}
            label={xAxisLabel}
            type="category"
            minTickGap={30}
            dataKey={xAxisKey}
            tickFormatter={xAxisTickFormatter}
          />
          <YAxis
            tick={{ fontSize: 16 }}
            interval={0}
            width={yAxisWidth}
            tickLine={false}
            axisLine={false}
            type="number"
            tickFormatter={yAxisTickFormatter}
          />
          <Tooltip
            content={
              <CustomTooltip
                includePercent={includePercent}
                tooltipFormatter={tooltipFormatter}
                tooltipLabelFormatter={tooltipLabelFormatter}
              />
            }
          />
          <CartesianGrid horizontal vertical={false} />
          <ReferenceLine
            x={UNIX_BAN_LIFTED}
            stroke="red"
            strokeDasharray="3 3"
          />
          <ReferenceLine x={UNIX_CDC} stroke="red" strokeDasharray="3 3" />
          <Annotation
            x={UNIX_BAN_LIFTED}
            textLabels={["Eviction ban", "expired"]}
            y="max"
            className="annotation__eviction-ban"
            arrowLineHeight={8}
            disableDynamicPos
            bottomPadding={1}
            defaultPos="left"
          />
          <Annotation
            className="annotation__cdc-order"
            x={UNIX_CDC}
            textLabels={["Federal", "order"]}
            y="max"
            arrowLineHeight={2}
            disableDynamicPos
            bottomPadding={1}
            defaultPos="right"
          />
          <Bar dataKey={yAxisKey} fill={schemeTableau10[0]} />
        </BarChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
};

Chart.defaultProps = {
  title: null,
  yAxisWidth: 80,
  includePercent: false,
  xAxisTickFormatter: null,
  xAxisLabel: null,
  xAxisHeight: 30,
  yAxisTickFormatter: null,
  tooltipFormatter: null,
  tooltipLabelFormatter: null,
};

Chart.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  xAxisKey: PropTypes.string.isRequired,
  xAxisTickFormatter: PropTypes.func,
  yAxisKey: PropTypes.string.isRequired,
  yAxisWidth: PropTypes.number,
  includePercent: PropTypes.bool,
  xAxisLabel: PropTypes.string,
  xAxisHeight: PropTypes.number,
  yAxisTickFormatter: PropTypes.func,
  tooltipFormatter: PropTypes.func,
  tooltipLabelFormatter: PropTypes.func,
};

export default Chart;
